import React from 'react';
import { Link } from 'react-router-dom';
import {
    message,
    Table,
    Tabs,
    Radio,
    Button,
    Modal,
    Form,
    Pagination,
    Row,
    Col,
    Icon,
    Input,
    Select,
    DatePicker,
    Spin,
    Popover
} from 'antd';
const FormItem = Form.Item;
const RangePicker = DatePicker.RangePicker;
const TabPane = Tabs.TabPane;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
import { onFieldsChange, getAgentsAndAreas, getStatisticTotal, getStatisticList,getExportUrl } from './action';
import { connect } from 'react-redux';
import constant from './constant';
import moment from 'moment';
import ReactEcharts from 'echarts-for-react';
import errImg from '../../../circleRed.png';

class OrderList extends React.Component {
    constructor(props) {
        super(props);
        this.handleOnFieldsChange = this.handleOnFieldsChange.bind(this);
        this.getOtion = this.getOtion.bind(this);
    }

    componentDidMount() {
        if (this.props.match.params.id) {
            let arr = this.props.match.params.id.split(',');
            let taskid = arr[0];
            this.props.onFieldsChange({ taskid: taskid });
            if (arr[1] && arr[2]) {
                let sTime = arr[1] + ' 00:00';
                let eTime = arr[2] + ' 23:59';
                this.props.onFieldsChange({
                    beginTimeView: moment(sTime, 'YYYY-MM-DD HH:mm'),
                    endTimeView: moment(eTime, 'YYYY-MM-DD HH:mm'),
                    beginTime: sTime,
                    endTime: eTime
                });
            }
        }
        //this.props.getAgentsAndAreas(); //查询地区和合作商列表
        //this.props.getStatisticTotal(); //查询任务统计的表格数据
        this.props.getStatisticList(); //查询任务统计的echarts数据
    }

    componentWillUnmount() {
        let _serach = this.props.search;
        let _obj = {};
        Object.keys(_serach).forEach((key, index) => {
            _obj[key] = '';
        });
        this.props.onFieldsChange(_obj);
    }

    handleOnFieldsChange(fields) {
        let _obj = {};
        Object.keys(fields).forEach((key, index) => {
            if (key === 'beginTimeView') {
                if (fields[key].value && fields[key].value > 0) {
                    let startTime = fields[key].value._d;
                    startTime.setHours(0);
                    startTime.setMinutes(0);
                    startTime.setSeconds(0);
                    startTime.setMilliseconds(0);
                    console.log(fields[key]);
                    _obj['beginTimeView'] = fields[key].value;
                    _obj['beginTime'] =
                        new Date(fields[key].value).getTime() == 0
                            ? ''
                            : moment(startTime.getTime()).format('YYYY-MM-DD HH:mm');
                    // _obj['beginTime'] ='2017-12-25 13:00';
                } else {
                    _obj['beginTimeView'] = null;
                    _obj['beginTime'] = null;
                }
            } else if (key === 'endTimeView') {
                if (fields[key].value && fields[key].value > 0) {
                    let endTime = fields[key].value._d;
                    endTime.setHours(23);
                    endTime.setMinutes(59);
                    endTime.setSeconds(59);
                    endTime.setMilliseconds(0);
                    _obj['endTimeView'] = fields[key].value;
                    _obj['endTime'] =
                        new Date(fields[key].value).getTime() == 0
                            ? ''
                            : moment(endTime.getTime()).format('YYYY-MM-DD HH:mm');
                    // _obj['endTime'] = '2017-12-25 14:00';
                } else {
                    _obj['endTimeView'] = null;
                    _obj['endTime'] = null;
                }
            } else {
                _obj[key] = fields[key].value;
            }
        });
        this.props.onFieldsChange(Object.assign(_obj));
        //this.fieldsOnChangeImpl(fields);
        this.props.getExportUrl();

    }

    fieldsOnChangeImpl(fields) {
        Object.keys(fields).forEach((key, index) => { });
    }

    getOtion(data, name) {
        const option = {
            title: {
                text: name,
            },
            tooltip: {
                trigger: 'axis',
            },
            legend: {
                data: data.legend,
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: 40,
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: data.xAxis,
            },
            // yAxis: {
            //     type: 'value',
            // },
            dataZoom: [
                {
                    type: 'inside',
                    start: 0,
                    end: 100,
                },
                {
                    start: 0,
                    end: 10,
                    handleIcon:
                        'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                    handleSize: '80%',
                    handleStyle: {
                        color: '#fff',
                        shadowBlur: 3,
                        shadowColor: 'rgba(0, 0, 0, 0.6)',
                        shadowOffsetX: 2,
                        shadowOffsetY: 2,
                    },
                },
            ],


            yAxis: function () {
                var yAxis = [];
                for (var i = 0; i < data.legend.length; i++) {
                    let dataName =  data.legend[i];
                    if(dataName.search("率")!=-1 || dataName.search("GAP")!=-1){
                        if(i==1){
                        var item = {
                            name: data.legend[i],
                            type: 'value',
                            position: 'left',
                            axisLabel: {
                                formatter: '{value} %',
                            },

                        };
                        yAxis.push(item);
                     }else{
                        var item = {
                            name: data.legend[i],
                            type: 'value',
                            position: 'right',
                            axisLabel: {
                                formatter: '{value} %',
                            },

                        };
                        yAxis.push(item);
                     }
                    }else{
                        if(i==1){
                            var item = {
                                name: data.legend[i],
                                type: 'value',
                                position: 'left',    
                            };
                            yAxis.push(item);
                         }else{
                            var item = {
                                name: data.legend[i],
                                type: 'value',
                                position: 'right',
                            };
                            yAxis.push(item);
                         }
                    }
                    // if (i == 0) {
                    //     var item = {
                    //         name: data.legend[i],
                    //         type: 'value',
                    //         position: 'left',
                    //         axisLabel: {
                    //             formatter: '{value}',
                    //         },

                    //     };
                    //     yAxis.push(item);
                    // } else if (i == 1) {
                    //     var item = {
                    //         name: data.legend[i],
                    //         type: 'value',
                    //         position: 'right',
                    //         //offset: 30,
                    //     };
                    //     yAxis.push(item);
                    // }
                    // } else {
                    //     var item = {
                    //         name: data.legend[i],
                    //         type: 'value',
                    //         position: 'right',
                    //         offset: 30,
                    //     };
                    //     yAxis.push(item);
                    // }

                }
                return yAxis;

            }(),

            series: function () {
                var series = [];

                for (var i = 0; i < data.legend.length; i++) {
                    let dataName =  data.legend[i];
                    if(dataName.search("率")!=-1 || dataName.search("GAP")!=-1){
                        var item = {
                            data: data.series[i],
                            symbol: 'none',
                            name: data.legend[i],
                            //barMaxWidth:30,
                            smooth: true,  //让曲线变平滑
                            yAxisIndex: i,   //显示不同的坐标轴
                            type: 'line',
                            itemStyle: {
                                normal: {
                                    label: {
                                        show: true,
                                        positiong: 'top',
                                        formatter: '{c}%'
                                    }
                                }
                            }

                        };
                        series.push(item);
                    }else{
                        var item = {
                            data: data.series[i],
                            symbol: 'none',
                            name: data.legend[i],
                            //barMaxWidth:30,
                            smooth: true,  //让曲线变平滑
                            yAxisIndex: i,   //显示不同的坐标轴
                            type: 'line',
                            itemStyle: { //itemStyle 是鼠标放在对应位置显示数字的
                                normal: {
                                    label: {
                                        show: true,
                                        positiong: 'top',
                                    }
                                }
                            }
                        };
                        series.push(item);
                    }
                    // var item = {
                    //     data: data.series[i],
                    //     symbol: 'none',
                    //     name: data.legend[i],
                    //     //barMaxWidth:30,
                    //     smooth: true,  //让曲线变平滑
                    //     yAxisIndex: i,   //显示不同的坐标轴
                    //     type: 'line',
                    //     //formatter:'{value}%'
                    // };
                    // series.push(item);
                }
                return series;

            }(),
        };

        return option;
    }





    cleaningEchartsData(taskStatisticData, key) {
        if (!taskStatisticData) {
            return {};
        }
        let source = taskStatisticData.name;
        let datas = taskStatisticData.map;
        let xAxisData = taskStatisticData.xAxis_data;
        let legendData11 = taskStatisticData.legendData;

        let cpmPrice = [];
        let aecpm = [];
        let icpm = [];

        let officialEv = [];
        let officialClick = [];
        let officialRate = [];

        let hzEv = [];
        let hzClick = [];
        let hzRate = [];

        let gapEv = [];
        let gapClick = [];
        let gapRate = [];

        if ('all' == source) {
            Object.keys(datas).forEach((_key, index) => {
                let detailData = datas[_key]; //_key="all"

                if (key == 'completeNum') {
                    detailData.forEach((item, index) => {
                        cpmPrice.push(item["cpmPrice"]);
                        aecpm.push(item["aecpm"]);
                        icpm.push(item["icpm"]);

                        officialEv.push(item["officialEv"]);
                        officialClick.push(item['officialClick']);
                        officialRate.push(item['officialRate']);

                        hzEv.push(item["hzEv"]);
                        hzClick.push(item['hzClick']);
                        hzRate.push(item['hzRate']);

                        gapEv.push(item["gapEv"]);
                        gapClick.push(item['gapClick']);
                        gapRate.push(item['gapRate']);

                    });
                }


            })
        }

        //  function seriesData1(){ 
        //  } 
        // seriesData1.optionData1 = series;
        // seriesData1.optionData2 = standers;
        // seriesData1.optionData3 = standards;



        let seriesData1 = [];
        if (legendData11 == null) {
            legendData11 = [];
            legendData11.push("官方曝光");
            legendData11.push("官方点击");
        }

        //给seriesData1第一个赋值
        let name1 = legendData11[0];
        if (name1 == "cpm单价") {
            seriesData1.push(cpmPrice);
        }
        if (name1 == "aecpm") {
            seriesData1.push(aecpm);
        }
        if (name1 == "icpm") {
            seriesData1.push(icpm);
        }
        if (name1 == "官方曝光") {
            seriesData1.push(officialEv);
        }
        if (name1 == "官方点击") {
            seriesData1.push(officialClick);
        }
        if (name1 == "官方点击率") {
            seriesData1.push(officialRate);
        }

        if (name1 == "hz曝光") {
            seriesData1.push(hzEv);
        }
        if (name1 == "hz点击") {
            seriesData1.push(hzClick);
        }
        if (name1 == "hz点击率") {
            seriesData1.push(hzRate);
        }
        if (name1 == "GAP曝光") {
            seriesData1.push(gapEv);
        }
        if (name1 == "GAP点击") {
            seriesData1.push(gapClick);
        }
        if (name1 == "GAP点击率") {
            seriesData1.push(gapRate);
        }
        //给seriesData1第二个赋值
        let name2 = legendData11[1];
        if (name2 == "cpm单价") {
            seriesData1.push(cpmPrice);
        }
        if (name2 == "aecpm") {
            seriesData1.push(aecpm);
        }
        if (name2 == "icpm") {
            seriesData1.push(icpm);
        }
        if (name2 == "官方曝光") {
            seriesData1.push(officialEv);
        }
        if (name2 == "官方点击") {
            seriesData1.push(officialClick);
        }
        if (name2 == "官方点击率") {
            seriesData1.push(officialRate);
        }

        if (name2 == "hz曝光") {
            seriesData1.push(hzEv);
        }
        if (name2 == "hz点击") {
            seriesData1.push(hzClick);
        }
        if (name2 == "hz点击率") {
            seriesData1.push(hzRate);
        }
        if (name2 == "GAP曝光") {
            seriesData1.push(gapEv);
        }
        if (name2 == "GAP点击") {
            seriesData1.push(gapClick);
        }
        if (name2 == "GAP点击率") {
            seriesData1.push(gapRate);
        }


        return {
            xAxis: xAxisData,
            series: seriesData1,//数组 顺序分别和legendData11所对应
            legend: legendData11,
        };
    }

    render() {
        let behaviourColumns = [
            {
                title: '索引位',
                dataIndex: 'index'
            },
            {
                title: '成功率',
                dataIndex: 'successRate',
                render: (text, record) => Number(record.behaviourSuccessCount / (record.behaviourSuccessCount + record.behaviourErrorCount) * 100).toFixed(2) + '%',
            }
        ]
        let columns = [
        ];
        const { statisticTotal, loading, statisticList } = this.props;

        return (
            <div style={{ marginBottom: '20px' }}>
                <Spin spinning={loading} tip="加载中">
                    <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                        <SearchForm {...this.props} handleOnFieldsChange={this.handleOnFieldsChange} />
                    </Row>
                    <Row className="graphs" style={{ marginTop: '10px', marginTop: '10px' }}>
                        <Col span={24} style={{ textAlign: 'center' }}>
                            <ReactEcharts
                                option={this.getOtion(this.cleaningEchartsData(statisticList, 'completeNum'), '成功量')}//填充曲线数据
                                style={{ height: '350px', width: '90%' }}
                                className="react_for_echarts"
                                notMerge={true}
                                lazyUpdate={true}
                            />
                        </Col>
                        {/* <Row className="graphs" style={{ marginTop: '10px', marginTop: '10px' }}>
                        <Col span={24} style={{ textAlign: 'center' }}>
                            <br/>
                            <input type="checkbox" name="advertPositionType" value="cpm单价"/><span>cpm单价  </span>
	                        <input type="checkbox" name="advertPositionType" value="aecpm" /><span>aecpm  </span>
                            <input type="checkbox" name="advertPositionType" value="icpm" /><span>icpm  </span>
	                        <input type="checkbox" name="advertPositionType" value="官方曝光" /><span>官方曝光  </span>
	                        <input type="checkbox" name="advertPositionType" value="官方点击" /><span>官方点击  </span>
	                        <input type="checkbox" name="advertPositionType" value="官方点击率" /><span>官方点击率  </span>
	                        <input type="checkbox" name="advertPositionType" value="恒紫曝光" /><span>恒紫曝光  </span>
	                        <input type="checkbox" name="advertPositionType" value="恒紫点击" /><span>恒紫点击  </span>
                            <input type="checkbox" name="advertPositionType" value="恒紫点击率" /><span>恒紫点击率  </span>
	                        <input type="checkbox" name="advertPositionType" value="GAP曝光" /><span>GAP曝光  </span>
	                        <input type="checkbox" name="advertPositionType" value="GAP点击" /><span>GAP点击  </span>
                            <input type="checkbox" name="advertPositionType" value="GAP点击率" /><span>GAP点击率  </span>
                        </Col>
                        </Row> */}

                    </Row>
                    {/* <Row className="wrapperBox" style={{ marginTop: '10px', marginTop: '10px' }}> */}
                    {/* </Row> */}
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.advertPositionDataCurve.loading.loading,
    search: state.advertPositionDataCurve.search,
    areas: state.advertPositionDataCurve.areas,
    agents: state.advertPositionDataCurve.agents,
    statisticTotal: state.advertPositionDataCurve.statisticTotal,
    statisticList: state.advertPositionDataCurve.statisticList,
    exportUrl: state.advertPositionDataCurve.url,

});

const mapDispatchToProps = dispatch => ({
    onFieldsChange: search => dispatch(onFieldsChange(search)),
    getAgentsAndAreas: () => dispatch(getAgentsAndAreas()),
    getStatisticTotal: () => dispatch(getStatisticTotal()),
    getStatisticList: () => dispatch(getStatisticList()),
    getExportUrl: () => dispatch(getExportUrl()),

});

export default connect(mapStateToProps, mapDispatchToProps)(OrderList);

class Search extends React.Component {
    constructor(props) {
        super(props);
        this.handleReset = this.handleReset.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    handleReset() {
        this.props.form.resetFields();
    }

    // 查询
    handleSearch(e) {

        e.preventDefault();
        // this.props.getStatisticTotal();//表格数据
        this.props.getStatisticList();//统计曲线数据
    }

    render() {
        const { areas, agents } = this.props;
        const { getFieldDecorator } = this.props.form;
        const queryTimes = [
            { name: '9点前', value: 1 },
            { name: '9点后', value: 2 },
            { name: '全天', value: 3 },
            { name: '9点后及全天', value: 4 },
        ];
        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>客户端运营数据统计</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row style={{ marginBottom: '10px' }}>
                        <Col span={4} >
                            <FormItem label="app" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('app')(<Input style={{ width: 200 }} placeholder="" />)}
                            </FormItem>
                        </Col>
                        <Col span={4} >
                            <FormItem label="广告平台" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('adPlatform')(
                                    <Select multiple allowClear placeholder="请选择" style={{ width: '200px' }}>
                                        <Option value="广点通">广点通</Option>
                                        <Option value="穿山甲">穿山甲</Option>
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem label="接入方式" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('joinWay')
                                    (
                                        <Select multiple allowClear placeholder="请选择" style={{ width: '200px' }}>
                                            <Option value="SDK">SDK</Option>
                                            <Option value="API">API</Option>
                                        </Select>,
                                    )}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem label="手机系统" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('phoneSystem')
                                    (
                                        <Select multiple allowClear placeholder="请选择" style={{ width: '200px' }}>
                                            <Option value="IOS">IOS</Option>
                                            <Option value="Android">Android</Option>
                                        </Select>,
                                    )}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem label="广告位" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('adPosition')
                                    (
                                        <Select multiple allowClear placeholder="请选择" style={{ width: '200px' }}>
                                            <Option value="信息流">信息流</Option>
                                            <Option value="开屏">开屏</Option>
                                            <Option value="banner">banner</Option>
                                        </Select>,
                                    )}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem label="taskId" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('taskId')(<Input style={{ width: 200 }} placeholder="" />)}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: '10px' }}>
                        <Col span={4}>
                            <FormItem label="开始时间" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('beginTm')(
                                    <DatePicker style={{ width: 200 }} showTime format="YYYY-MM-DD" />,
                                )}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem label="结束时间" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('endTm')(
                                    <DatePicker style={{ width: 200 }} showTime format="YYYY-MM-DD" />,
                                )}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem label="曲线" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('curve')
                                    (
                                        <Select multiple allowClear placeholder="请选择" style={{ width: '200px' }}>
                                            <Option value="cpm单价">cpm单价</Option>
                                            <Option value="aecpm">aecpm</Option>
                                            <Option value="icpm">icpm</Option>
                                            <Option value="官方曝光">官方曝光</Option>
                                            <Option value="官方点击">官方点击</Option>
                                            <Option value="官方点击率">官方点击率</Option>
                                            <Option value="hz曝光">hz曝光</Option>
                                            <Option value="hz点击">hz点击</Option>
                                            <Option value="hz点击率">hz点击率</Option>
                                            <Option value="GAP曝光">GAP曝光</Option>
                                            <Option value="GAP点击">GAP点击</Option>
                                            <Option value="GAP点击率">GAP点击率</Option>
                                        </Select>,
                                    )}
                            </FormItem>
                        </Col>
                        {/* <Col span={4}>
                            <FormItem label="曲线2" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('curve2')
                                    (
                                        <Select allowClear placeholder="请选择" style={{ width: '200px' }}>
                                            <Option value="cpm单价">cpm单价</Option>
                                            <Option value="aecpm">aecpm</Option>
                                            <Option value="icpm">icpm</Option>
                                            <Option value="官方曝光">官方曝光</Option>
                                            <Option value="官方点击">官方点击</Option>
                                            <Option value="官方点击率">官方点击率</Option>
                                            <Option value="hz曝光">hz曝光</Option>
                                            <Option value="hz点击">hz点击</Option>
                                            <Option value="hz点击率">hz点击率</Option>
                                            <Option value="GAP曝光">GAP曝光</Option>
                                            <Option value="GAP点击">GAP点击</Option>
                                            <Option value="GAP点击率">GAP点击率</Option>
                                        </Select>,
                                    )}
                            </FormItem>
                        </Col> */}
                    </Row>
                    <Row>
                        <Col span={24} style={{ textAlign: 'center', marginTop: '10px', marginBottom: '20px' }}>
                            <Button style={{ marginLeft: 8 }} onClick={this.handleReset}>
                                重置
                            </Button>&nbsp;&nbsp;&nbsp;&nbsp;
                            <Button type="primary" htmlType="submit">
                                搜索
                            </Button>
                            <Button style={{ marginLeft: 8 }} >
                                <a href={this.props.exportUrl} download="filename">导出</a>
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}
const SearchForm = Form.create({
    onFieldsChange(props, fields) {
        props.handleOnFieldsChange(fields);
    },
    mapPropsToFields(props) {
        return {
            app: {
                value: props.search.app,
            },
            adPlatform: {
                value: props.search.adPlatform,
            },
            joinWay: {
                value: props.search.joinWay,
            },
            phoneSystem: {
                value: props.search.phoneSystem,
            },
            adPosition: {
                value: props.search.adPosition,
            },
            beginTm: {
                value: props.search.beginTm,
            },
            endTm: {
                value: props.search.endTm,
            },
        };
    },
})(Search);



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/advertPositionDataCurve/index.js